import { NextPage } from 'next';

import CarSubscriptionPage from '@components/common/CarSubscriptionPage/CarSubscriptionPage';

const SubscriptionCars: NextPage = () => {
  return <CarSubscriptionPage pageLink="subscription-cars" />;
};

export default SubscriptionCars;
